var _path, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrowRight(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_38_44",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 40,
    height: 40
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40 0H0V40H40V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_38_44)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.18717 11.2964C3.02907 6.97961 7.68003 2.42163 11.9479 4.67627V4.67725L14.5143 6.04346L14.5231 6.04834L14.5309 6.05225C14.7427 6.15811 14.8942 6.32524 14.9723 6.51611L14.9772 6.52783L14.9831 6.53955L24.4645 27.6177V27.6187C24.6904 28.1297 24.4801 28.7188 24.0046 28.9663L24.0006 28.9683L11.9342 35.3179L11.9323 35.3188C7.68438 37.5728 3.02699 33.0216 5.18717 28.7007L8.08756 22.9009L8.08854 22.8979C8.99227 21.0717 8.99227 18.942 8.08854 17.1157L8.08756 17.1138L5.18815 11.2974L5.18717 11.2964Z",
    stroke: "#265185",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.5891 11.7236C21.3632 10.8822 22.2705 10.114 23.0804 10.5459L23.0833 10.5479L32.7005 15.6143C36.2496 17.4829 36.2496 22.5511 32.7005 24.4199L29.3098 26.1992C28.7741 26.4719 28.1244 26.2513 27.8675 25.6924L21.6507 11.8926V11.8916L21.5891 11.7236Z",
    stroke: "#187550",
    strokeWidth: 1.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRight);
export default __webpack_public_path__ + "static/media/arrow_right.fbf4d9101c8f37ffe8433f73c2ef3c25.svg";
export { ForwardRef as ReactComponent };